'use strict';
(function($){

	var $form = $('#create-order-form');
	var $orderRowsInput = $form.find('#order-rows-input');

	var rows = 0;
	var generateOrderRow = function(data){
		var $orderRowTpl = $('#order-row-prototype');
		var $newOrderRow = $orderRowTpl.clone();
		$newOrderRow.attr('id',null);
		++rows;

		var id_order_rows = (typeof data != 'undefined' && typeof data.id_order_rows != 'undefined' )? data.id_order_rows : '';
		$newOrderRow.find('#id-order-rows-input').attr('id','id-order-rows-input-' + rows).attr('name', 'id-order-rows-input-' + rows).val(id_order_rows);

		$newOrderRow.find('[for="description-input"]').attr('for','description-input-' + rows);
		var description = (typeof data != 'undefined' && typeof data.description != 'undefined' )? data.description : '';
		$newOrderRow.find('#description-input').attr('id','description-input-' + rows).attr('name', 'description-' + rows).val(description);

		$newOrderRow.find('[for="code-input"]').attr('for','code-input-' + rows);
		var code = (typeof data != 'undefined' && typeof data.code != 'undefined' )? data.code : '';
		$newOrderRow.find('#code-input').attr('id','code-input-' + rows).attr('name', 'code-' + rows).val(code);

		$newOrderRow.find('[for="quantity-input"]').attr('for','quantity-input-' + rows);
		var quantity = (typeof data != 'undefined' && typeof data.quantity != 'undefined' )? data.quantity : '';
		$newOrderRow.find('#quantity-input').attr('id','quantity-input-' + rows).attr('name', 'quantity-' + rows).val(quantity);

		var $orderRows = $('.order-rows');
		$orderRows.append($newOrderRow);
	}

	if($orderRowsInput.length > 0 && $orderRowsInput.val() != ''){
		var orderRows = [];
		try{
			var orderRows = JSON.parse($orderRowsInput.val());
		}catch(err){
			console.log(err);
		}
		if(Array.isArray(orderRows)){
			orderRows.forEach(function(orderRow, index){
				if(index == 0){
					var id_order_rows = (typeof orderRow != 'undefined' && typeof orderRow.id_order_rows != 'undefined' )? orderRow.id_order_rows : '';
					$form.find('#id-order-rows-input').val(id_order_rows);
					var description = (typeof orderRow != 'undefined' && typeof orderRow.description != 'undefined' )? orderRow.description : '';
					$form.find('#description-input').val(description);
					var code = (typeof orderRow != 'undefined' && typeof orderRow.code != 'undefined' )? orderRow.code : '';
					$form.find('#code-input').val(code);
					var quantity = (typeof orderRow != 'undefined' && typeof orderRow.quantity != 'undefined' )? orderRow.quantity : '';
					$form.find('#quantity-input').val(quantity);
				}else{
					generateOrderRow(orderRow);
				}
			});
		}
	}

	$(document).on('click','button.btn-more', function(){
		$form.find('.is-invalid').removeClass('is-invalid');
		generateOrderRow({
			id_order_rows : '',
			description : '',
			code : '',
			quantity : ''
		});
	});

	$('#create-order-submit, #save-order-submit, #complete-order-submit').click(function(ev){
		ev.preventDefault();
		var data = [];
		var $message = $form.find('[name="comments"]');
		var $orderRows = $form.find('.order-row');
		var invalid = false;
		var emptyDescriptions = true;
		$form.closest('.box').find('.alert').remove();
		$form.find('.is-invalid').removeClass('is-invalid');

		$orderRows.each(function(){

			var $description = $(this).find('.description').find('input');

			// if( $description.val() == '' ) {
			// 	$description.addClass('is-invalid');
			// 	invalid = true;
			// }

			var $code = $(this).find('.code').find('input');
			// if( $code.val() == '' ) {
			// 	$code.addClass('is-invalid');
			// 	invalid = true;
			// }

			var $quantity = $(this).find('.quantity').find('input');

			var emptyRow = $description.val() == '';
			if(emptyDescriptions) emptyDescriptions = emptyRow;

			emptyRow = $code.val() == '' && emptyRow;
			emptyRow = $quantity.val() == '' && emptyRow;
			if(emptyRow) return false;

			if($message.val() == ''){
				if( $description.val() != '') {
				//if( $quantity.val() == '' && $description.val() != '') {
					$quantity.addClass('is-invalid');
					invalid = 'quantity field.';
				}
			}

			data.push({
				'id_order_rows' : $(this).find('input[type="hidden"]').val(),
				'description' : $description.val(),
				'code' : $code.val(),
				'quantity' : $quantity.val(),
			})
		});

		if( !invalid && ( $message.val() == '' && emptyDescriptions ) ) {
			$message.addClass('is-invalid');
			invalid = 'message or description fields.';
		}

		if(invalid) {
			var invalidHtml = '';
			invalidHtml += '<div class="alert alert-danger" role="alert">';
			invalidHtml += 'Please fill ' + invalid;
			invalidHtml += '<button type="button" class="close" data-dismiss="alert" aria-label="Close">';
			invalidHtml += '<span aria-hidden="true">&times;</span>';
			invalidHtml += '</button>';
			invalidHtml += '</div>';

			$form.closest('.box').prepend(invalidHtml);
			return false;
		}

		$orderRowsInput.val(JSON.stringify(data));
		var $func = $('<input>').attr({
			type: 'hidden',
			name: 'func',
			value: $(this).val()
		});
		$form.append($func).submit();
		return false;
	});

	$(document).on('click','button.btn-less', function(){
		var $orderRows = $(this).closest('.order-row');
		if($orderRows.attr('id') == 'order-row-prototype'){
			$orderRows.next('.order-row').attr('id','order-row-prototype');
			$orderRows.next('.order-row').find('input[type="hidden"]').attr('id','#id-order-rows-input');
			$orderRows.next('.order-row').find('.description').find('input').attr('id','#description-input').attr('name','description');
			$orderRows.next('.order-row').find('.description').find('label').attr('for','description-input');
			$orderRows.next('.order-row').find('.code').find('input').attr('id','#code-input').attr('name','code');
			$orderRows.next('.order-row').find('.code').find('label').attr('for','code-input');
			$orderRows.next('.order-row').find('.quantity').find('input').attr('id','#quantity-input').attr('name','quantity');
			$orderRows.next('.order-row').find('.quantity').find('label').attr('for','quantity-input');
		}
		if($('.order-row').length > 1){
			$orderRows.remove();
		}else{
			$form.find('#id-order-rows-input').val('');
			$form.find('#description-input').val('');
			$form.find('#code-input').val('');
			$form.find('#quantity-input').val('');
		}
	});

	$form.find('input').on('change', function(){
		if($(this).val() != ''){
			$(this).removeClass('is-invalid');
		}
	});

}(jQuery));
